export default "__VITE_PUBLIC_ASSET__cb4c449f__"